import $				 from 'cash-dom';
import Alpine			from 'alpinejs';
import htmx			  from 'htmx.org';
import intlTelInput	  from 'intl-tel-input';
import { gsap }		  from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';


/**
 * Cache
 */
var $body = $('body');


/**
 * Remove no JS class
 */
$('html').removeClass('no-js')
		 .addClass('js');


/**
 * Phone input
 */
Alpine.nextTick(() => {
	
	var phoneInput = document.querySelector('main input[name="phone"]');

	var iti = intlTelInput(phoneInput, {

		utilsScript: './intl-tel-input-utils.js',
		initialCountry: 'auto',
		geoIpLookup: function(success, failure) {

			fetch('https://ipapi.co/json')
			.then(function(res) { return res.json(); })
			.then(function(data) { success(data.country_code); })
			.catch(function() { failure(); });

		},
		separateDialCode: true,
		strictMode: true

	});

});


/**
 * Make global
 */
window.htmx = htmx; 
window.Alpine = Alpine;


/**
 * Start Alpine
 */
Alpine.start();


/**
 * HTMX POST-only
 */
$body.on('htmx:beforeRequest', (evt) => {

	const requestConfig = evt.detail.requestConfig;

	if (requestConfig && requestConfig.method) {

		const method = requestConfig.method.toUpperCase();

		if (method !== 'POST') {

			evt.preventDefault();
			
			console.error(`Security Policy: HTMX ${method} requests are prohibited`);

		}

	}

});


/**
 * Background
 */
window.addEventListener('mousemove', (e) => {
	
	const normX = (e.clientX / window.innerWidth - 0.5) * 2;
	const normY = (e.clientY / window.innerHeight - 0.5) * 2;
	
	const moveAmountX = -40;
	const moveAmountY = -25;

	gsap.to('main div.bg div.image', {

		duration: 1.2,
		x: normX * moveAmountX,
		y: normY * moveAmountY,
		scale: 1.15,
		ease: "power2.out",
		force3D: true

	});

});


/**
 * Find ot more
 */
$('main div.content div.find-out-more a.button').on('click', function(e) {

	e.preventDefault();

	const tl = gsap.timeline({
		onStart: () => {

			$('body').addClass('form-visible');

		}

	});

	tl.to('main div.content div.find-out-more', {

		duration: 0.6,
		opacity: 0,
		scale: 0.95,
		ease: 'power2.out'

	})
	.set('main div.content div.find-out-more', { display: 'none' })
	.set('main div.content div.form', { display: 'block', opacity: 1 })
	.fromTo('main div.content div.form',
		{
			height: 0,
			paddingTop: 0,
			paddingBottom: 0,
			overflow: 'hidden'
		},
		{
			duration: 0.8,
			height: 'auto',
			paddingTop: '',
			paddingBottom: '',
			clearProps: 'overflow',
			ease: 'power3.inOut'
		}
	)
	.fromTo('main div.content div.form > *', 
		{

			opacity: 0,
			y: 20

		},
		{

			duration: 1.0,
			opacity: 1,
			y: 0,
			stagger: 0.08,
			ease: 'power3.out'

		},
		"-=0.5"

	);

});